var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-dialog modal-xl" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title" }, [_vm._v("Select an item")]),
        _vm._v(" "),
        _c("button", {
          staticClass: "btn-close",
          attrs: { type: "button", "aria-label": "Close" },
          on: {
            click: function ($event) {
              return _vm.$emit("hide-modal")
            },
          },
        }),
      ]),
      _vm._v(" "),
      _setup.view.tableName
        ? _c(
            "div",
            { staticClass: "modal-body p-0" },
            [
              _c(
                "header",
                [
                  _c("div", { staticClass: "d-flex border-bottom" }, [
                    _c(
                      "div",
                      { staticClass: "flex-fill" },
                      [
                        _setup.show
                          ? _c(
                              _setup.Button,
                              {
                                staticClass: "rounded-0",
                                nativeOn: {
                                  click: function ($event) {
                                    return _setup.showAddItemModal.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_c("i", { staticClass: "bi-plus-lg" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(_setup.ListingOptionsSearchModalBtn, {
                          attrs: { "view-id": _setup.viewId },
                        }),
                        _vm._v(" "),
                        _c(_setup.SearchFiltersResetBtn, {
                          attrs: { "view-id": _setup.viewId },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c(_setup.ListingOptionsPaginationMetrics, {
                          attrs: { "view-id": _setup.viewId },
                        }),
                        _vm._v(" "),
                        _c(_setup.ListingOptionsPreviousBtn, {
                          staticClass: "ms-1",
                          attrs: { "view-id": _setup.viewId },
                        }),
                        _vm._v(" "),
                        _c(_setup.ListingOptionsNextBtn, {
                          staticClass: "ms-1",
                          attrs: { "view-id": _setup.viewId },
                        }),
                        _vm._v(" "),
                        _c(_setup.ListingOptionsMenu, {
                          staticClass: "ms-1",
                          attrs: { "view-id": _setup.viewId },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(_setup.SearchFilterToolbar, {
                    attrs: { "view-id": _setup.viewId },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _setup.isOdp
                ? _c(
                    "div",
                    [
                      _c(_setup.OdpCourseDatesCoursesMenu, {
                        attrs: { "view-id": _setup.viewId },
                      }),
                      _vm._v(" "),
                      _c(_setup.OdpCourseDatesSchoolsMenu, {
                        attrs: { "view-id": _setup.viewId },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.viewMode === "table" || !_setup.viewMode
                ? _c(_setup.TableView, {
                    staticClass: "m-3",
                    attrs: { "view-id": _setup.viewId },
                  })
                : _setup.viewMode === "thumbnail"
                ? _c(_setup.GridView, {
                    staticClass: "m-3",
                    attrs: { "view-id": _setup.viewId },
                  })
                : _vm._e(),
            ],
            1
          )
        : _c("div", { staticClass: "modal-body p-5 text-center" }, [_vm._m(0)]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [
        _c("span", { staticClass: "visually-hidden" }, [
          _vm._v("Loading listing..."),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }